import { FEATURE_TO_TITLE } from 'hooks/dialogs/cluster/constants';

import {
  AgentSetupBlock,
  AgentSetupBlockProps,
} from './_components/AgentSetupBlock';
import { AgentSetupCompleteBlock } from './_components/AgentSetupCompleteBlock';
import FeatureLabel from './_components/FeatureLabel';

type SetupProps = Pick<
  AgentSetupBlockProps,
  'checked' | 'onChange' | 'hasBeenInstalled' | 'showCheckbox'
>;

type CompleteProps = {
  checked?: boolean;
};

const heading = FEATURE_TO_TITLE.gpuMetricsExporter;

export const AgentGpuMetricsSetup = (props: SetupProps) => {
  return (
    <AgentSetupBlock
      heading={heading}
      description="Monitor GPU utilization and performance to maximize resource efficiency"
      isNestedBlock
      labelChip={<FeatureLabel />}
      testId="gpu-metrics-exporter"
      {...props}
    />
  );
};

export const AgentGpuMetricsComplete = ({ checked }: CompleteProps) => {
  return (
    <AgentSetupCompleteBlock
      heading={heading}
      testId="agent-gpu-exporter-complete"
      isNestedBlock
      checked={checked}
    />
  );
};
